import { Common } from "@secondcloset/types";
import { getAPIFromDomain } from "../../lib/api";

interface FetchUserRolesQuery {
  organization_id?: string;
}

interface Role {
  id: string;
  name: string;
  permissions: Common.Permission[];
}

export const fetchUserRole = async (roleID: string): Promise<Role> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.get(`roles/${roleID}`);
  return res.data;
};

export const fetchUserRoles = async (query: FetchUserRolesQuery): Promise<Role[]> => {
  const api = getAPIFromDomain("accounts");
  const res = await api.get("roles", {
    params: query,
  });
  return res.data;
};
